/* @flow */

import React from 'react';

import styles from './ErrorBox.module.scss';

export type ErrorBoxProps = {
  level: 'warning' | 'error',
  message: string,
};

class ErrorBox extends React.PureComponent<ErrorBoxProps> {
  render() {
    const { level, message } = this.props;

    return (
      <div className={`${styles.errorBox} ${styles[level]}`}>
        <svg>
          <use xlinkHref={`#icon-error`} />
        </svg>
        <span>{message}</span>
      </div>
    );
  }
}

export default ErrorBox;
